import React, { useState, useEffect } from 'react';
import { collection, onSnapshot, query, orderBy } from 'firebase/firestore';
import { db } from '../../Firebaseconfig';
import Card from '../Home/Card';

function TestProduct() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    // Fetch products ordered by creation date (newest first)
    const q = query(collection(db, 'products'), orderBy('createdAt', 'desc'));
    const unsub = onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setProducts(data);
      setLoading(false);
    });
    
    // Cleanup listener on unmount
    return () => unsub();
  }, []);

  return (
    <>
      <style>
        {`
          .tp-container {
            padding: 30px;
            font-family: 'Inter', sans-serif;
            color: #e2e4f3;
            max-width: 1200px;
            margin: 0 auto;
          }
          .tp-title {
            font-size: 28px;
            font-weight: 700;
            margin-bottom: 24px;
            background: linear-gradient(90deg, #fff, #94a3b8);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
          .tp-grid {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
            gap: 24px;
          }
        `}
      </style>

      <div className="tp-container">
        <h2 className="tp-title">Available Products</h2>
        
        {loading ? (
          <div style={{ textAlign: 'center', padding: '60px', color: '#94a3b8' }}>
            <div style={{ fontSize: 16 }}>Loading products...</div>
          </div>
        ) : products.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '60px', color: '#94a3b8', background: 'rgba(255,255,255,0.02)', borderRadius: 16, border: '1px dashed rgba(255,255,255,0.1)' }}>
            <div style={{ fontSize: 18, marginBottom: 8, color: '#e2e4f3' }}>No products yet</div>
            <div>Be the first to add a product!</div>
          </div>
        ) : (
          <div className="tp-grid">
            {products.map(product => (
              <Card
                key={product.id}
                product={product}
              />
            ))}
          </div>
        )}
      </div>
    </>
  );
}

export default TestProduct;